<template>
  <div v-if="!!!submissionFormData">
    <v-simple-table>
      <template #default>
        <tr v-for="i in 3" :key="i">
          <td class="px-2" v-for="i in 4" :key="i">
            <v-skeleton-loader
              type="text"
              class="mt-4 skeleton-fill-height"
              height="24"
            />
          </td>
        </tr>
      </template>
    </v-simple-table>
  </div>
  <div v-else-if="!!submissionApplicationData">
    <v-container>
      <v-row>
        <v-col cols="12" md="6">
          <div class="d-flex mb-6 align-baseline pl-4" :style="{ gap: '16px' }">
            <div class="text-h6 font-weight-bold">{{ $t("titleMsg") }}:</div>
            <div class="text-h6">{{ submissionApplicationData.title }}</div>
          </div>
        </v-col>
        <v-col v-if="currentTab === 'pending_applications'" cols="12" md="6" class="d-flex justify-end">
          <v-btn
            depressed
            color="secondary"
            class="text-none"
            :loading="downloadApplicationMtn.isLoading.value"
            :disabled="downloadApplicationMtn.isLoading.value"
            @click="
              downloadApplicationMtn.mutate({
                serverPath: submissionApplicationData.item_path,
                filename: submissionApplicationData.title,
              })
            "
          >
            {{ $t("downloadMsg") }}
            <v-icon class="ml-2">mdi-download-circle-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-simple-table class="application-table">
        <template #default>
          <tbody>
            <tr>
              <!-- <td class="font-weight-bold">{{ $t("titleMsg") }}:</td>
              <td>
                {{ submissionApplicationData.title }}
              </td> -->
              <td class="font-weight-bold">{{ $t("programmeMsg") }}:</td>
              <td colspan="3">
                {{
                  normalizedFormData.communities[
                    submissionApplicationData.community_id
                  ].name
                }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t("projectMsg") }}:</td>
              <td>
                {{
                  getCollection(
                    submissionApplicationData.collection_id,
                    normalizedFormData.communities[
                      submissionApplicationData.community_id
                    ].collection
                  ).name
                }}
              </td>
              <td class="font-weight-bold">
                {{ $t("viewMoreCountry") }}
              </td>
              <td>
                {{
                  normalizedFormData.countries[
                    submissionApplicationData.country_id
                  ].name
                }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">
                {{ $t("eventOrPublishDateMsg") }}:
              </td>
              <td>
                {{
                  submissionApplicationData.eventDate | moment("DD-MMM-YYYY")
                }}
              </td>
              <td class="font-weight-bold">{{ $t("classificationMsg") }}:</td>
              <td>
                {{
                  normalizedFormData.classifications[
                    submissionApplicationData.classification_id
                  ].name
                }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t("accessLevelMsg") }}:</td>
              <td>
                {{
                  normalizedFormData.access_levels[
                    submissionApplicationData.access_level_id
                  ].name
                }}
              </td>
              <td class="font-weight-bold">{{ $t("coordinatesMsg") }}:</td>
              <td>
                {{ submissionApplicationData.latitude }}
                {{ submissionApplicationData.longitude }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t("uploadedByMsg") }}:</td>
              <td>{{ getUsername(application.uploaded_by) }}</td>
              <td class="font-weight-bold">{{ $t("uploadedOnMsg") }}:</td>
              <td>
                {{ application.created_at | moment("DD-MMM-YYYY HH:mm:ss") }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t("descriptionMsg") }}:</td>
              <td colspan="3">{{ submissionApplicationData.description }}</td>
            </tr>
            <tr>
              <td>{{ $t("tagsMsg") }}</td>
              <td colspan="3">
                <v-chip
                  class="mr-1"
                  v-for="(tag, index) in submissionApplicationData.tags"
                  :key="index"
                >
                  {{ tag }}
                </v-chip>
              </td>
            </tr>
            <tr v-if="!!submissionApplicationData.abstract">
              <td class="font-weight-bold">{{ $t("abstractMsg") }}:</td>
              <td colspan="3">
                <div>{{ submissionApplicationData.abstract }}</div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<style scoped>
.application-table :deep(table) {
  table-layout: fixed;
}
</style>

<script setup>
import {
  convertArrayOfObjsToObj,
  getUsername,
} from "@/components/Utils/functions";
import apiCall from "@/utils/api";
import { downloadFile } from "@/utils/download_file";
import { useMutation } from "@tanstack/vue-query";
import { computed, onMounted, ref } from "vue";

const props = defineProps({
  application: {
    type: Object,
  },
  submissionFormData: {
    type: Object,
  },
  currentTab: {
    type: String,
  },
});

const submissionApplicationData = ref(null);

onMounted(() => {
  const isSubmissionApplication = props.application.submission_id !== undefined;
  if (isSubmissionApplication) {
    setSubmissionApplicationData(props.application);
  }
});

const normalizedFormData = computed(() => {
  if (!!!props.submissionFormData) {
    return {};
  }
  return Object.entries(props.submissionFormData).reduce(
    (finalValue, [key, value]) => {
      finalValue[key] = convertArrayOfObjsToObj(value, "id");
      return finalValue;
    },
    {}
  );
});

function getCollection(collectionId, collections) {
  return collections.find((collection) => collection.id === collectionId);
}

function setSubmissionApplicationData(application) {
  submissionApplicationData.value = JSON.parse(application.metadata).new;
  console.log(normalizedFormData.value);
}

const downloadApplicationMtn = useMutation({
  mutationFn: async ({ serverPath }) => {
    return await apiCall(
      {
        url: `/api/download-submission-application?filepath=${serverPath}`,
        method: "GET",
      },
      {
        responseType: "blob",
      }
    );
  },
  onSuccess(resp, { serverPath, filename }) {
    const extension = serverPath.split(".").pop();
    downloadFile(resp, `${filename}.${extension}`);
  },
});
// const fileDownloading = ref(false)
// async function downloadApplicationFile(serverPath, filename) {
//   try{
//     fileDownloading = true
//   const resp =
//   const extension = serverPath.split(".").pop();
//   // downloadFile(resp, `${filename}.${extension}`);
//   }finally{
//     fileDownloading = false
//   }
// }
</script>

<script>
export default {
  data() {
    return {
      workflowActionLog: null,
      wfApprovers: [],
    };
  },
  created() {},
  methods: {
    getApproversList(application_type, application) {
      apiCall({
        url: "/api/workflowapprovers",
        data: {
          application_type: application_type,
          application: JSON.stringify(application),
        },
        method: "POST",
      })
        .then((resp) => {
          this.wfApprovers = resp;
          console.log(JSON.stringify(resp));
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
  },
};
</script>
